module.exports = __webpack_public_path__ + "static/media/credit-card-bg.8ee526da.svg";